import { render, staticRenderFns } from "./PointLog.vue?vue&type=template&id=68ad1de5&scoped=true"
import script from "./PointLog.vue?vue&type=script&lang=js"
export * from "./PointLog.vue?vue&type=script&lang=js"
import style0 from "./PointLog.vue?vue&type=style&index=0&id=68ad1de5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad1de5",
  null
  
)

export default component.exports